import { render } from "./DiscountDetailsModal.vue?vue&type=template&id=98cff13e&scoped=true"
import script from "./DiscountDetailsModal.vue?vue&type=script&lang=js"
export * from "./DiscountDetailsModal.vue?vue&type=script&lang=js"

import "./DiscountDetailsModal.vue?vue&type=style&index=0&id=98cff13e&lang=less&scoped=true"

import exportComponent from "C:\\REPOS\\pos-web-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98cff13e"]])

export default __exports__